// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__402XE","search":"Settings_search__1eqpJ","filter":"Settings_filter__11T1n"};